import React, { Component } from "react";
import ChildLetterTile from "./ChildLetterTile";
const CHILD_LETTER_CODE = ["CCS", "YCS"];

class MediaTile extends Component {
  constructor(props) {
    super(props);
  }
  
  isChildLetterMedia(mediaData) {
    
    for (let i = 0; i <= CHILD_LETTER_CODE.length; i++) {
      if (
        mediaData &&
        mediaData.contentTypeCode &&
        mediaData.contentTypeCode.toUpperCase() === CHILD_LETTER_CODE[i]
      ) {
        return true;
      }
    }

    return false;
  }

  isCommunity(mediaData) {
    return mediaData.mediaType.toLowerCase() != "child";
  }

  getVideoThumbnail(media) {
    const keys = Object.keys(media);
    //check if vthumb exits else return nothing.
    if (keys.includes("vthumb")) {
      const vthumb = Object.keys(media["vthumb"]);
      const videoCover = media["vthumb"][vthumb] ? media["vthumb"][vthumb] : "";
      return videoCover["url"];
    } else {
      return false;
    }
  }

  getTitle(isCommunity, isVideo) {
    let mediaTitle = isCommunity ? "Community " : "Child ";
    mediaTitle = isVideo ? mediaTitle + "Video" : mediaTitle + "Photo";
    return mediaTitle;
  }

  // Validate required data exists. If it doesn't, don't show the tile.
  getIsValidMedia(mediaData) {
    if (!mediaData.contentTypeCode || !mediaData.mediaType) {
      return false;
    }

    return true;
  }

  getMediaObjToShow(media, getMediaFormat) {
    const mediaFormatted = getMediaFormat(media);
    const key =  Object.keys(mediaFormatted)[0];
    const mediaObj = mediaFormatted[key];
    const ctCode = mediaObj.contentTypeCode;

    // if child letter then use original instead of default media handling order
    if (CHILD_LETTER_CODE.includes(ctCode)) {
        return media.original;
    }
    return getMediaFormat(media);
  }

  render() {
    const { isChildLetterMedia } = this;
    const { media, getMediaFormat, getIsVideo, childData } = this.props;
    const mediaToShow = this.getMediaObjToShow(media, getMediaFormat);
    const key = Object.keys(mediaToShow)[0];
    const mediaData = mediaToShow[key];
    
    if (!this.getIsValidMedia(mediaData)) {
      // Show Nothing In This Case
      return <div />;
    }

    const isChildLetter = isChildLetterMedia(mediaData);
    const isCommunity = this.isCommunity(mediaData);
    const isVideo = getIsVideo(mediaData);

    let mediaTitle = this.getTitle(isCommunity, isVideo);

    const galleryHeadingClass = isCommunity
      ? "tile__title gallery__heading gallery__heading--community-photo"
      : "tile__title gallery__heading gallery__heading--child-photo";

    const url = mediaToShow[key].url;
    const caption = mediaToShow[key].captionForSupporter;

    const videoCover = isVideo ? this.getVideoThumbnail(media) : "";

    if (isChildLetter) {
      return (
        <ChildLetterTile
          mediaData={mediaData}
          childData={childData}
          isCommunity={isCommunity}
        />
      );
    }

    // Display Video
    if (isVideo) {
      const showControls = !window.matchMedia("(min-width: 768px)").matches;

      return (
        <div className="tile" onClick={() => this.props.handleClick(url)}>
          <p className={galleryHeadingClass}>
            <i className="fa fa-video-camera" /> {mediaTitle}
          </p>
          <video
            controls={showControls}
            className="tile__video"
            type="video/mp4"
            poster={videoCover}
          >
            <source src={url} />
            Your browser does not support the video tag.
          </video>

          <i className="gallery__icon gallery__icon--video fa fa-play-circle" />
          <p className="tile__caption gallery__description"></p>
          <p className="tile__description gallery__description">{caption}</p>
        </div>
      );
    }

    // Default Display
    return (
      <div className="tile" onClick={() => this.props.handleClick(url)}>
        <p className={galleryHeadingClass}>
          <i className="fa fa-picture-o" /> {mediaTitle}
        </p>
        <img className="tile__img" src={url} alt="" />
        <i className="fa fa-search-plus gallery__icon gallery__icon--image" />
        <p className="tile__caption gallery__description"></p>
        <p className="tile__description gallery__description">{caption}</p>
      </div>
    );
  }
}

export default MediaTile;
